import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link as RouteLink } from 'react-router-dom';
import config from '../../config';

import { Form, ResetOnSuccess, setErrors, InputField, Field, AutoFillSpy, ToggleSwitch } from '../form';
import AutoSaveToSession from '../form/AutoSaveToSession';

import arrayMutators from 'final-form-arrays';
import setFieldData from 'final-form-set-field-data';


import filter from 'lodash/filter';
import first from 'lodash/first';
import size from 'lodash/size';
import keys from 'lodash/keys';
import map from 'lodash/map';
import each from 'lodash/each';
import difference from 'lodash/difference';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import classNames from 'classnames';


import SignupModalTrigger from '../auth/SignupModalTrigger';
import ActivateModalTrigger from '../billing/ActivateModalTrigger';
import AccountLimitsError from '../billing/AccountLimitsError';



import { sublinksUrlDecorator } from '../SmartLinks/BioLinkButtonsTab';

import PreloadUniqueSlug from '../Links/PreloadUniqueSlug';



import { addLinkSuccess, listPixelSets } from '../../actions';

import { FormSpy } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';


import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  FormGroup,
  Button
} from 'reactstrap';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ModalLink from '../modals/ModalLink';

import currencyFormatter from 'currency-formatter';

// Icons
import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';

import faPlus from '@fortawesome/fontawesome-pro-light/faPlus';
import faEyeSlash from '@fortawesome/fontawesome-pro-light/faEyeSlash';
import faBars from '@fortawesome/fontawesome-pro-light/faBars';
import faStarSolid from '@fortawesome/fontawesome-pro-solid/faStar';
import faClock from '@fortawesome/fontawesome-pro-light/faClock';
import faImage from '@fortawesome/fontawesome-pro-regular/faImage';



import faLayoutCard from '../../icons/layouts/faLayoutCard';
import faLayoutButton from '../../icons/layouts/faLayoutButton';
import faLayoutThumbnail from '../../icons/layouts/faLayoutThumbnail';
import faLayoutImageBg from '../../icons/layouts/faLayoutImageBg';
import faLayoutText from '../../icons/layouts/faLayoutText';
import faLayoutFeed from '../../icons/layouts/faLayoutFeed';



import IconPickerAdapter from '../helpers/IconPickerAdapter';
import Loading from '../helpers/Loading';
import DateRangePicker from '../helpers/DateRangePicker';



import { UrlScraper } from '../Links/urlScraper';
import NetworkIcon from '../SmartLinks/NetworkIcon';

import sublinksScheme from '../SmartLinks/schemes';
import SchemedField from '../SmartLinks/SchemedField';


import { isSubscribedSelector, currentUserSelector, currentAccountSelector } from '../../reducers/selectors';

import { scrapeFeed } from '../../api';

import ReactFilestack from 'filestack-react';


import preventDefault from '../../utils/preventDefault';

import Theme from './Theme';
import SettingsButton from './SettingsButton';
import AvatarUploader from './AvatarUploader';
import SmartPageActionBar from './SmartPageActionBar';
import SmartPageActionSheet from './SmartPageActionSheet';
import SmartPageFTE from './SmartPageFTE';

const mapStateToProps = state => ({currentUser:currentUserSelector(state), currentAccount:currentAccountSelector(state), isSubscribed: isSubscribedSelector(state)});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ addLinkSuccess, listPixelSets }, dispatch)
};


let feedData = {}


const networkTitles = {
  messenger: "Messenger",
  whatsapp: "WhatsApp",
  telegram: "Telegram",
  skype: "Skype",
  viber: "Viber",
  wechat: "WeChat",
  facebook: "Facebook",
  instargam: "Instargam",
  twitter: "Twitter",
  youtube: "Youtube",
  pinterest: "Pinterest",
  patreon: "Patreon",
  tumblr: "Tumblr",
  vk: "VK",
  linkedin: "LinkedIn",
  snapchat: "Snapchat",
  email: "Email",
  call: "Phone",
}


const getDndListStyle = isDraggingOver => ({
  // background: isDraggingOver ? 'lightblue' : 'lightgrey',
  // padding: 8,
  // width: 250,
  // paddingTop: '1rem'
});

const getDndItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  // styles we need to apply on draggables
  ...draggableStyle,
});


const text2HTML = (text) => {
  if (!text)
    return text
  const html = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r\n?|\n/gi, "<br />").replace(/<br \/>\s*<br \/>/g, "</p><p>");
  return "<p>" + html + "</p>";
}


class SublinksList extends Component {
  
  constructor(props) {
    super(props);
    this.onDragEnd = this.onDragEnd.bind(this);
  }
  
  onDragEnd(result) {
    const { fields } = this.props
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    
    // good times
    if (window.navigator.vibrate) {
      window.navigator.vibrate(100);
    }
    
    fields.move(result.source.index, result.destination.index)
  }
  
  render() {
    const { fields, children } = this.props
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getDndListStyle(snapshot.isDraggingOver)}
            >
              {fields.map((name, index) => (
                <Draggable key={name} draggableId={name} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={getDndItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                    >
                      {children({provided, snapshot, name, index})}
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
}

const SchemedList = ({scheme, fields, submitting, deleteOnly}) => {
  const selectedFields = fields.value ? map(fields.value, 'type') : []
  const placeholder = <NetworkIcon type={first(difference(keys(scheme), selectedFields)) || 'facebook'} />
  
  return (<SublinksList submitting={submitting} fields={fields}>
    {({provided, snapshot, name, index}) => {
      const fieldValue = fields.value[index];
      if (!fieldValue)
        return null
      
      return (<FormGroup className="with-stack">
      <div className={classNames({"side-controls":true, "drag-handle":true, 'd-none': fields.length <= 1})} {...provided.dragHandleProps}>
        <FA icon={faBars} />
      </div>
      
      <SchemedField nodropdown={true} {...{name, fieldValue, placeholder, scheme, submitting, selectedFields}} />
      
    </FormGroup>)
    }}
  </SublinksList>)
}



class BlocksList extends Component {
  
  constructor(props) {
    super(props);
    this.onDragEnd = this.onDragEnd.bind(this);
  }
  
  onDragEnd(result) {
    const { fields } = this.props
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    
    // good times
    if (window.navigator.vibrate) {
      window.navigator.vibrate(100);
    }
    
    fields.move(result.source.index, result.destination.index)
  }
  
  render() {
    const { focus, fields, values, push, unshift, submitting, pristine, setActionSheet, hideActionSheet } = this.props
    
    return (
      <DragDropContext onDragEnd={this.onDragEnd} onDragStart={hideActionSheet}>
       	<AddBlockButton focus={focus} push={push} unshift={unshift} submitting={submitting} values={values} setActionSheet={this.setActionSheet} hideActionSheet={this.hideActionSheet} />
        
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getDndListStyle(snapshot.isDraggingOver)}
            >
              {fields.map((name, index) => (
                <Draggable key={name} draggableId={name} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      style={getDndItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                    >
                      <Block {...{provided, snapshot, name, index, fields, values, submitting, pristine, setActionSheet, hideActionSheet}} />
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
}


class AddBlockButton extends Component {
  
  constructor (props){
    super(props)
    
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.selectBlockType = this.selectBlockType.bind(this);
    
    this.state = {
      dropdownOpen: false
    }
  }
  
  toggleDropdown (){
    this.setState({dropdownOpen: !this.state.dropdownOpen})
  }
  
  selectBlockType (layoutType){
    // ["text", "button", "button-thumbnail", "button-image-bg", "card"]
    const { focus, unshift } = this.props;
    const defaultProps = {url: "", layout: layoutType || "button"};
    
    
    return (e) => {
      preventDefault(e);
      this.toggleDropdown();
      focus('settings.blocks');
      const initProps = {...defaultProps, ...(layoutTypes[layoutType].initProps || {})};
      setTimeout( () => unshift('settings.blocks', initProps) );
    }
  }
  
  render() {
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} className="add-block-dropdown btn-block">
        
        <DropdownToggle className="add-block-button btn-block">
          <span><FA icon={faPlus} /> Add Block</span>
        </DropdownToggle>
        
        <DropdownMenu>
          
          <div className="dropdown-item" onClick={this.selectBlockType("button")}>
            <span><FA icon={layoutTypes['card'].icon} className="fa-icon" /></span> Button or Card
          </div>
          <div className="dropdown-item" onClick={this.selectBlockType("text")}>
            <span><FA icon={layoutTypes['text'].icon} className="fa-icon" /></span> Subtitle and Text
          </div>
          
          <div className="dropdown-item" onClick={this.selectBlockType("feed-mixed")}>
            <span className="shake"><FA icon={layoutTypes['feed'].icon} className="fa-icon" /></span> Dynamic feed
          </div>
          
          <div className="dropdown-item" onClick={this.selectBlockType("countdown")}>
            <span><FA icon={layoutTypes['countdown'].icon} className="fa-icon" /></span> Countdown
          </div>
          
          
        </DropdownMenu>
      </Dropdown>
    );
  }
};


class MessengersList extends Component {
  
  constructor (props){
    super(props)
    this.openEditor = this.openEditor.bind(this)
  }
  
  openEditor (e) {
    preventDefault(e);
    
    const { fields, setActionSheet, push } = this.props;
    
    const values = (fields || {}).value || []
    const types = keys(sublinksScheme['messengers'])
    each(types, (type) => {
      if (findIndex(values, {type}) === -1){
        push(fields.name, {type: type});
      }
    });
    
    setActionSheet({ActionComponent: MessengersSettings, title: "Messengers", props: this.props});
  }
  
  
  render (){
    const { values: { settings } } = this.props
    const { messengers } = settings || {}
    const filteredMessengers = filter(messengers, (m) => m.url && m.handle);
    
    const messengersNum = size(filteredMessengers)
    const className = classNames({[`blocks-num-${messengersNum}`]: true, 'messengers': true})
    
    return messengersNum === 0 ? <AddMessengersButton onClick={this.openEditor} /> : <div className={className}>
      {map(filteredMessengers, ({type}) => <div key={`${type}`} className="links-block"><div className="block-item layout-button" onClick={this.openEditor}>
        <span>
          <NetworkIcon type={type} />
          {type && networkTitles[type] && <span>{networkTitles[type]}</span>}
        </span>
      </div></div>)}
    </div>
  }
}






const AddMessengersButton = ({onClick}) => (
  <div className="add-block-button" onClick={onClick}>
    <span><FA icon={faPlus} /> Add Messengers</span>
  </div>
)



class SocialLinksList extends Component {
  
  constructor (props){
    super(props)
    this.openEditor = this.openEditor.bind(this)
  }
  
  openEditor (e) {
    preventDefault(e);
    
    const { fields, setActionSheet, push } = this.props;
    
    const values = (fields || {}).value || []
    const types = keys(sublinksScheme['social_links'])
	
    each(types, (type) => {
      if (findIndex(values, {type}) === -1){
        push(fields.name, {type: type});
      }
    });
    
    setActionSheet({ActionComponent: SocialLinksSettings, title: "Social Links", props: this.props});
  }
  
  
  render (){
    const { values: { settings } } = this.props
    const { social_links } = settings || {}
    const filteredItems = filter(social_links, 'url');
    
    const itemsNum = size(filteredItems)
    const className = classNames({[`blocks-num-${itemsNum}`]: true, 'social-links': true})
    
    return itemsNum === 0 ? <AddSocialLinksButton onClick={this.openEditor} /> : <div className={className}>
      {map(filteredItems, ({type}) => <div key={`${type}`} className="social-item" onClick={this.openEditor}>
        <span><NetworkIcon type={type} /></span>
      </div>)}
    </div>
  }
}

const AddSocialLinksButton = ({onClick}) => (
  <div className="add-block-button add-social-links" onClick={onClick}>
    <span><FA icon={faPlus} /> Add Social Links</span>
  </div>
)






const blockFilestackOptions = {
  accept: ["image/*"],
  maxSize: 1024 * 1024 * 3, // 3 Mb max file size
  transformations: {
    crop: true,
    circle: false,
    rotate: true
  },
  imageMax: [1200, 1200]
}
const parsePriceLabelString = (block) => ((price, toValue) => {
  
  if (!price)
    return toValue;
  
  const currency = (get(block, 'meta.currency') || 'USD').toUpperCase();
  const res = currencyFormatter.format(price, {code: currency });
  
  if (currency !== 'USD' && currency.match(/D$/gi))
    return `${res} ${currency}`;
  return res;
})


// const parseBlockIdOnUrlChange = (block) => ((urlValue, toValue) => {
//   if (!block.id || !urlValue || urlValue === '')
//     return undefined;
//   
//   return block.id;
// })


const BlockSettings = ({fields, values, submitting, index, name, setActionSheet, hideActionSheet}) => {
  const block = values.settings.blocks[index];
  
  const { layout } = block;
  const layoutType = layoutTypes[layout] || {}
  const LayoutSettingsBlock = layoutType.SettingsComponent || ButtonBlockSettings;
  const PreviewComponent = layoutType.BlockComponent || ButtonComponent;
  const hideControls = layoutType.hideControls;
  
  const isFeed = (layout || '').match(/feed/i);
  
  return (<div>
    
    <AutoFillSpy from={`${name}.meta.title`} to={`${name}.title`} />
    <AutoFillSpy from={`${name}.meta.youtube_video_id`} to={`${name}.layout`} parse={(youtube_video_id, toValue) => (!!youtube_video_id && (!toValue || toValue === 'button') ? 'card' : toValue )} />
    <AutoFillSpy from={`${name}.meta.rss[0].href`} to={`${name}.feed_url`} />
    
    <AutoFillSpy from={`${name}.meta.price`} to={`${name}.label.name`} parse={parsePriceLabelString(block)} />
    
    
    <UrlScraper urlField={`${name}.url`} dataField={`${name}.meta`} />
    
    <LayoutSettingsBlock {...{layout, block, submitting, name}} />
    
    <div className="smartpage-container block-preview">
      <div className="links-block">
        <PreviewComponent name={name} {...block} />
      </div>
    </div>
    
    { !hideControls && !(isFeed && isEmpty(block.feed_url)) && <FormGroup className="text-center block-controls">
      <Field 
        name={`${name}.highlight`}
        render={({input}) => <span onClick={() => input.onChange(!input.value)} className={classNames({"block-control": true, disabled: layout === 'text' || isFeed, active: input.value})}>
          <span><FA icon={faStarSolid} /></span>
          Pop
        </span>}
      />
      <Field 
        name={`${name}.hide`}
        render={({input}) => <span onClick={() => input.onChange(!input.value)} className={classNames({"block-control": true, active: input.value})}>
          <span><FA icon={faEyeSlash} /></span>
          Hide
        </span>}
      />
      <Field 
        name={`${name}.schedule_enabled`}
        render={({input}) => <span onClick={() => input.onChange(!input.value)} className={classNames({"block-control": true, active: input.value})}>
          <span><FA icon={faClock} /></span>
          Schedule
        </span>}
      />
      </FormGroup>}
      
      
      {(!hideControls && block.schedule_enabled === true) && <FormGroup>
        <Field name={`${name}.schedule`}>
          {({input}) => <DateRangePicker {...input} />}
        </Field>
      </FormGroup>}
      
      
  </div>)
}

const ButtonBlockSettings = ({layout, block, submitting, name}) => (<React.Fragment>
  <FormGroup className="with-loading">
    <InputField 
      meta={{submitting}}
      name={`${name}.url`} type="text"
      placeholder="http://url..."
      focusOnMount={isEmpty(block.url) && 400}
    />
    <Field
      name={`${name}.meta`}
      subscription={{ data: true }}
      render={({ meta: { data: {loading}}}) => (
        (loading && <Loading />) || null
      )}
    />
  </FormGroup>
  
  <FormGroup>
    <div className="input-group input-stack-row">
      { layout === 'button' ? <Field
        className="input-group-prepend"
        name={`${name}.icon`}
        placeholder={"Icon"}
        component={IconPickerAdapter}
      /> :
        <div className="input-group-prepend">
          <Field name={`${name}.image`}>
            {({ input }) => (
              <ReactFilestack
                apikey={config.filestackKey}
                actionOptions={blockFilestackOptions}
                onSuccess={(res) => 
                  input.onChange(get(res, 'filesUploaded[0].url', null))
                }
                customRender={({ onPick }) => (
                  <Button className="btn-outline-border" color="secondary" onClick={onPick}><FA icon={faImage} className="fa-icon" /></Button>
                )} 
              />
            )}
          </Field>
        </div>
      }
      <InputField
        meta={{submitting}}
        name={`${name}.title`} type="text"
        placeholder="Title"
      />
    </div>
  </FormGroup>
  
  {layout !== 'button' && <Row>
    <Col xs={7} sm={6} className="form-group">
      <InputField
        meta={{submitting}}
        name={`${name}.label.name`} type="text"
        placeholder="Price tag (label)"
      />
    </Col>

    <Col xs={5} sm={6} className="form-group" style={{padding: 0}}>
      {layout !== "button-thumbnail" && get(block, 'label.name') && <Field
        name={`${name}.label.color`}
        render={({input}) => 
        <div className="colorpicker" style={{transform: 'scale(0.7)', transformOrigin: 'center left'}}><ul>
          {map(["#4CD964", '#EB5757', "#F2C94C"], (i) => <li key={i} className={classNames({selected: i === (input.value || "#4CD964")})} style={{backgroundColor: i}} onClick={() => input.onChange(i)}></li>)}
        </ul></div>
      }
      />}
    </Col>
  </Row>}
  
    
  <Field 
    name={`${name}.layout`}
    render={({input}) => <div className="layout-selector">
      {map(["button", "button-thumbnail", "button-image-bg", "card"], (layout, k) =>
        <span key={k} title={layoutTypes[layout].name} className={classNames({selected: input.value === layout})} onClick={(e) => input.onChange(layout)}><FA icon={layoutTypes[layout].icon} /></span>
      )}
      {!block.id && (!!(block.meta || {}).rss) && <span title={layoutTypes['feed'].name} className={classNames({selected: input.value === 'feed', highlight: true, shake: true})} onClick={(e) => input.onChange('feed-mixed')}><FA icon={layoutTypes['feed'].icon} /></span>}
    </div>}
  />
    
  
</React.Fragment>);


const TextBlockSettings = ({layout, block, submitting, name}) => (<React.Fragment>
  <FormGroup>
    <InputField
      meta={{submitting}}
      name={`${name}.title`} type="text"
      placeholder="Title"
    />
  </FormGroup>
  
  <FormGroup>
    <InputField 
      meta={{submitting}}
      name={`${name}.text`} type="textarea"
      placeholder="Text"
    />
  </FormGroup> 
      
</React.Fragment>);





class FeedBlockSettings extends Component {
  
  constructor (props){
    super(props);
    this.toggleFeedForm = this.toggleFeedForm.bind(this);
    this.state = {
      showGetFeedFromUrlScreen: isEmpty( get(this.props, 'block.feed_url') )
    }
  }
  
  componentWillReceiveProps (nextProps) {
    if (!this.state.showGetFeedFromUrlScreen)
      return
    const feed_url = get(nextProps, 'block.feed_url');
    
    if (feed_url && get(this.props, 'block.feed_url') !== feed_url)
      this.toggleFeedForm();
  } 
  
  toggleFeedForm (e) {
    if (e)
      e.preventDefault();
    
    const {name} = this.props
    this.setState({showGetFeedFromUrlScreen: !this.state.showGetFeedFromUrlScreen});
    setTimeout( () => 
      document.getElementById && document.getElementById(`${name}.feed_url`) && document.getElementById(`${name}.feed_url`).focus()
    , 100);
  }
  
  render () {
    const { submitting, name, block } = this.props;
    const { showGetFeedFromUrlScreen } = this.state;
    
    return (<React.Fragment>
      <UrlScraper urlField={`${name}.feed_url`} passErrors={true} dataField={`${name}.feed_data`} queryParams={{nocache: true}} scrapeFunction={scrapeFeed} />
      
      {(!showGetFeedFromUrlScreen) ? <DynamicFeedSettings {...this.props} /> : <React.Fragment>

        <label className="small gray">Get feed from url</label>
        <FormGroup className="with-loading">
          <InputField 
            meta={{submitting}}
            name={`${name}.url`} type="text"
            placeholder="http://url..."
            focusOnMount={isEmpty(block.url) && 400}
          />
          <Field
            name={`${name}.meta`}
            subscription={{ data: true }}
            render={({ meta: { data: {loading}}}) => (
              (loading && <Loading />) || null
            )}
          />
        </FormGroup>
        
        
        {(block && block.meta && !block.meta.rss) && <div className="alert alert-warning">No feed were found, please try another URL</div>}
        
        <div className="text-center mt-4">
          <img alt="" src="/img/feed-suggestions.png" style={{width: "100%", maxWidth: "400px", opacity: "0.6"}} />
          <div className="gray mt-2">or any website with the feed (rss/atom)</div>
          <div className="small gray mt-1">
            <Button color="link" onClick={this.toggleFeedForm}>put rss/atom feed url</Button>
          </div>
        </div>
      </React.Fragment>}
    </React.Fragment>)
  }
}


const DynamicFeedSettings = ({id, layout, block, submitting, name}) =>(<React.Fragment>
  {!id && <AutoFillSpy from={`${name}.feed_data.title`} to={`${name}.title`} />}
  
  <FormGroup>
    <InputField
      meta={{submitting}}
      name={`${name}.title`} type="text"
      placeholder="Title"
    />
  </FormGroup>
  
  <FormGroup className="with-loading">
    <InputField 
      meta={{submitting}}
      id={`${name}.feed_url`}
      name={`${name}.feed_url`} type="text"
      placeholder="Feed url (RSS/Atom)"
    />
    <Field
      name={`${name}.feed_data`}
      subscription={{ data: true }}
      render={({ meta: { data: {loading}}}) => (
        (loading && <Loading />) || null
      )}
    />
  </FormGroup>
  
  
  
  <Row>
    <Col xs={12} sm={6} className="form-group">
      <label className="small gray ">Layout</label>
      <Field 
        name={`${name}.layout`} type="text"
        render={({input}) => (
          <select className="form-control" {...input}>
            <option value="feed-mixed" key="feed-mixed">Mixed</option>
            <option value="feed" key="feed">Thumbnails</option>
            <option value="feed-cards" key="feed-cards">Cards</option>
            <option value="feed-tiles" key="feed-tiles">Tiles</option>
          </select>
        )}
      />
    </Col>
  
    <Col xs={12} sm={6} className="form-group">
      <label className="small gray">Items</label>
      <Field 
        name={`${name}.feed_items_num`} type="number"
        render={({input}) => (
          <select className="form-control" {...input}>
            {map([5,4,3,2,1], (i) => (<option key={i}>{i}</option>))}
          </select>
        )}
      />
    </Col>
  </Row>
  
  {layout === 'feed-tiles' && <FormGroup className="with-loading">
    <label style={{fontWeight: 'normal'}}><Field 
      name={`${name}.hide_titles`}
      render={({input}) => <ToggleSwitch input={{...input, checked: !!input.value}} />} 
    /> hide titles</label> 
  </FormGroup>}
  
</React.Fragment>);


const CountdownSettings = ({id, layout, block, submitting, name}) =>(<React.Fragment>
    
  <AutoFillSpy from={`${name}.meta.image`} to={`${name}.image`} />
  
  <FormGroup>
    <Field name={`${name}.schedule`}>
      {({input}) => <DateRangePicker {...input} />}
    </Field>
  </FormGroup>
  
  
  <FormGroup className="text-center">
    <Field name={`${name}.image`}>
      {({ input }) => (
        !input.value ? <ReactFilestack
          apikey={config.filestackKey}
          actionOptions={blockFilestackOptions}
          onSuccess={(res) => 
            input.onChange(get(res, 'filesUploaded[0].url', null))
          }
          customRender={({ onPick }) => (
            <Button className="btn-outline-border btn-rounded" color="secondary" onClick={onPick}><FA icon={faImage} className="fa-icon" /> Upload Image</Button>
          )} 
        /> :
          <div className="background-image-btn" style={{borderRadius: '2rem'}} onClick={() => input.onChange(null)}>
            <style dangerouslySetInnerHTML={{__html: [`.background-image-btn::after{ background-position: 50% 50%; background-image: url('${input.value}') !important; }`]}}></style>
            <span><FA icon={faImage} className="fa-icon" /> Remove Image</span>
          </div>
      )}
    </Field>
  </FormGroup>
  
  
  <FormGroup>
    <InputField
      meta={{submitting}}
      name={`${name}.title`} type="text"
      placeholder="Title"
    />
  </FormGroup>
  
  <FormGroup>
    <InputField 
      meta={{submitting}}
      name={`${name}.text`} type="textarea"
      placeholder="Text"
    />
  </FormGroup>
  
  <FormGroup className="with-loading">
    <InputField 
      meta={{submitting}}
      name={`${name}.url`} type="text"
      placeholder="http://url..."
      focusOnMount={isEmpty(block.url) && 400}
    />
    <Field
      name={`${name}.meta`}
      subscription={{ data: true }}
      render={({ meta: { data: {loading}}}) => (
        (loading && <Loading />) || null
      )}
    />
  </FormGroup>
  

  { block.url && <Row>
    <Col xs={7} sm={6} className="form-group">
      <InputField
        meta={{submitting}}
        name={`${name}.label.name`} type="text"
        placeholder="Call to action button"
      />
    </Col>

    <Col xs={5} sm={6} className="form-group" style={{padding: 0}}>
      {layout !== "button-thumbnail" && get(block, 'label.name') && <Field
        name={`${name}.label.color`}
        render={({input}) => 
        <div className="colorpicker" style={{transform: 'scale(0.7)', transformOrigin: 'center left'}}><ul>
          {map(["#4CD964", '#EB5757', "#F2C94C"], (i) => <li key={i} className={classNames({selected: i === (input.value || "#4CD964")})} style={{backgroundColor: i}} onClick={() => input.onChange(i)}></li>)}
        </ul></div>
      }
      />}
    </Col>
  </Row>}
  
  
</React.Fragment>);



// gleb was here
const filestackThumbnail = (imageUrl, transformation = 'resize=w:160,h:160,fit:crop') => (
  imageUrl && imageUrl.match('filestackcontent.com') ? imageUrl.replace(/(\/\w+\/?)$/, `/${transformation}$1`) : imageUrl
)

const filestackCompress = (imageUrl) => filestackThumbnail(imageUrl, 'quality=v:80/no_metadata/cache=expiry:max/compress=m:true');



const shouldHideBlock = ({hide, schedule_enabled, schedule}) => {
  if ( hide === true)
    return true;
  
  return schedule_enabled === true && hideBySchedule(schedule);
}

const hideBySchedule = (schedule = {}) => {
  const now = new Date();
  const start = schedule.start_at && new Date(schedule.start_at);
  const end = (schedule.end_at && new Date(schedule.end_at)) || now;
  
  if ( !start || !end )
    return false;
  
  return !(now >= start && now <= end); 
}

const ButtonComponent = ({name, title, icon, type, layout, label, image, meta, onClick, highlight, hide, schedule_enabled, schedule, preloadContent}) => {
  const _meta = (meta || {})
  const _image = image || (meta || {}).image
  const _title = (type && networkTitles[type]) || title || (meta || {}).title
  
  const { youtube_video_id } = _meta;
  
  return (
    <div className={classNames({'block-item': true, [`layout-${layout}`]: !!layout, highlight, hide: shouldHideBlock({hide, schedule_enabled, schedule}), schedule_enabled, 'play-button': !!youtube_video_id})} style={{backgroundImage: layout === 'button-image-bg' && `url('${filestackCompress(_image)}')`}} onClick={onClick}>
      {schedule_enabled && <FA icon={faClock} className="schedule-indicator" />}
      
      { !_image && preloadContent && 
        <UrlScraper urlField={`${name}.url`} dataField={`${name}.meta`} />
      }
      
      
      { layout === 'card'  && (_image && !title) && label && label.name && <strong className="block-label" style={{backgroundColor: label.color}}>{label.name}</strong>}
      
      { layout && layout !== 'button' && _image && layout !== 'button-image-bg' && 
        (layout === "button-thumbnail" ? 
          <div className="thumbnail"  style={{backgroundImage:`url('${filestackThumbnail(_image)}')`}} /> 
        : 
          <div className="button-image"><img src={filestackCompress(_image)} alt="" /></div>
      )}
      
      { layout === 'button' && (<div className="block-content">
          { icon && <FA icon={icon.replace("fa-", "").split(" ")} className="fa-block-icon" /> }
          <span>{ _title || 'Name your link'}</span>
      </div>)}
      
      { layout !== 'button' && (title || !_image) && <div className="block-content">
        <div>{_title || 'Name your link'}</div>
        { label && label.name && <strong className="block-label" style={{backgroundColor: label.color}}>{label.name}</strong>}
      </div>}
      
    </div>
  )
}

const TextComponent = ({text, title, highlight, hide, schedule_enabled, schedule}) => (
  <div className={classNames({'block-item': true, "layout-text": true, highlight, schedule_enabled, hide: shouldHideBlock({hide, schedule_enabled, schedule}) })}>
    { schedule_enabled && <FA icon={faClock} className="schedule-indicator" /> }
    { title && <h2 className="block-title">{title}</h2> }
    { text && <div className="block-text" dangerouslySetInnerHTML={{__html: text2HTML(text)}} /> }
  </div>
)


class FeedSpyComponent extends Component {
  
  constructor(props){
    super(props);
    this.loadFeed = this.loadFeed.bind(this)
    this.state = {
      loading: false, 
      error: false
    }
  }
  
  componentWillMount (){
    this.loadFeed();
  }
  
  componentWillUnmount (){
    this.setState({loading: false});
  }
  
  componentWillReceiveProps (nextProps){
    if ( nextProps.feed_data && nextProps.feed_data !== this.props.feed_data )
      this.loadFeed(nextProps.feed_data);
    
    if ( nextProps.feed_url !== this.props.feed_url ){
      this.setFeed({}, true);
      
    
      const fieldState = this.props.form.getFieldState(this.props.toField);
      if (isEmpty(nextProps.feed_data) && !fieldState)
        setTimeout(this.loadFeed);
    }
  }
  
  setFeed (feed, noCache) {
    const {to, form, feed_url} = this.props;
    if (typeof to === 'function')
      to(feed);
    else
      form.change(to, feed);
    
    if (!noCache)
      feedData[feed_url] = feed;
    this.setState({loading: false, error: false});
  }
  
  async loadFeed (data){
    const {feed_url, nocache} = this.props;
    if (data){
      this.setFeed(data);
    }
    else if (!isEmpty(feed_url)){
      this.setState({loading: true});
      try{
        const feed = feedData[feed_url] || await scrapeFeed({url: feed_url, nocache});
        this.setFeed(feed);
      } catch (e){
        this.setFeed({});
        this.setState({loading: false, error: true});
      }
    }
  }
  
  render (){
    const { form, toField, children, feed_data} = this.props;
    let {loading, error} = this.state;
    
    const fieldState = form.getFieldState(toField);
    if (fieldState && fieldState.data && typeof fieldState.data.loading !== 'undefined' )
      loading = fieldState.data.loading || this.state.loading;
    
    if (feed_data && !isEmpty(feed_data.error))
      error = true;
    
    return !error ? (loading ? <Loading /> : children) : <div className="feed-error text-center">No feed found</div>;
  }
}


const FeedItems = ({feed_data, feed_items_num, layout, schedule_enabled}) => {
  const data = feed_data || {}
  const feedItems = data.items || [];
  
  
  return map(feedItems.slice(0, feed_items_num || 5), (item, idx) => {
    let item_layout = (layout === 'feed-cards' || (layout === 'feed-mixed' && idx === 0))? 'card' : 'button-thumbnail';
    
    const hasPlayBtn = (item.link || '').match(/youtube.com|youtu.be/)
    
    return (<div key={idx} title={item.title} className={classNames({'block-item': true, [`layout-${item_layout}`]: !!layout, "play-button": hasPlayBtn})}>
      { idx === 0 && schedule_enabled && <FA icon={faClock} className="schedule-indicator" /> }
      {item.image && item_layout === 'button-thumbnail' && <div className="thumbnail" style={{backgroundImage: `url('${item.image}')`}}></div>}
      {item.image && item_layout !== 'button-thumbnail' && <div className="button-image"><img src={item.image} alt="" /></div>}
      {item.image && layout === 'feed-tiles' && <img src={item.image} alt="" />}
      {item.title && <span className="block-content">{item.title}</span>}
    </div>)
  })
}

class FeedBlockComponent extends Component {
  constructor (props) {
    super(props);
    this.updateFeed = this.updateFeed.bind(this);
    this.state = {
      feed_data: {}
    }
  }
  
  updateFeed (feed_data) {
    this.setState({feed_data: feed_data})
  }
  
  render () {
    const { name, layout, title, feed_url, feed_items_num, hide_titles, schedule_enabled, schedule } = this.props;
    const feed_data = this.props.feed_data || this.state.feed_data;
    const hide = shouldHideBlock({hide: this.props.hide, schedule_enabled, schedule});
    
    return (feed_url ? <React.Fragment>
      {title && <div className="links-block"><div className={classNames({"block-item":true, "layout-text":true, hide})}><h2 className="block-title">{title}</h2></div></div>}
      <div className={classNames({[`layout-${layout}`]:true, hide, [`items-num-${feed_items_num}`]: true, hide_titles})}>
        <FormSpy
          toField={`${name}.feed_data`}
          to={this.updateFeed}
          {...{feed_url, feed_data: this.props.feed_data}}
          subscription={{values: true}}
          component={FeedSpyComponent}
        >
          <FeedItems {...{feed_data, feed_items_num, layout, hide_titles, schedule_enabled}} />
        </FormSpy>
      </div>
    </React.Fragment> : null)
  }
}



class Countdown extends React.Component {
  constructor (props) {
    super(props);
    this.interval = null
    this.countDownNumbers = this.countDownNumbers.bind(this);
    this.state = this.countDownNumbers();
  }
  
  initCountdown (){
    if (this.interval)
      clearInterval(this.interval);
    
    this.interval = setInterval( () => this.setState(this.countDownNumbers()), 1000)
  }
  
  componentDidMount (){
    this.initCountdown()
  }
  
  componentWillUnmount (){
    if (this.interval)
      clearInterval(this.interval);
  }
  
  componentWillReceiveProps (nextProps){
    const { end_at } = this.props;
    if (nextProps.end_at !== end_at)
      this.initCountdown();
  }
  
  countDownNumbers (){
    const { end_at } = this.props;
    
    if (!end_at)
      return {}
    
    const countDownDate = new Date(end_at).getTime();
    const now = new Date().getTime();
    const distance = countDownDate - now;
    
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    if (distance <= 0 && this.interval){
      clearInterval(this.interval);
    }
    
    return {days, hours, minutes, seconds, distance};
  }
  
  render () {
    const { end_at } = this.props;
    const { days, hours, minutes, seconds, distance } = this.state;
    
    return ( end_at && distance > 0 ? <div className="countdown">
      {days > 0 && <div><span className="number">{days}</span><span className="num-name">DAYS</span></div>}
      <div><span className="number">{hours}</span><span className="num-name">HRS</span></div>
      <div><span className="number">{minutes}</span><span className="num-name">MIN</span></div>
      <div><span className="number">{seconds}</span><span className="num-name">SEC</span></div>
    </div> : <div className="countdown expired">
      EXPIRED
    </div>
    )
  }
}


const CountdownComponent = ({ image, hide, layout, title, text, label, meta, schedule, url }) => {

  const _hide = shouldHideBlock({hide: hide, schedule_enabled: true, schedule});
  const cardStyle = !!(image || title || text || url)
  
  return (schedule ? <React.Fragment>
    <div className={classNames({'block-item': true, [`layout-${layout}`]:true, "card-style": cardStyle, hide: _hide})}>
      { image && <div className="block-image"><img src={filestackCompress(image)} alt="" /></div> }
      <div className="block-content">
        { title && <h2 className={classNames({'block-title': true, 'text-center': !text})}>{title}</h2> }
        { text && <div className="block-text" dangerouslySetInnerHTML={{__html: text2HTML(text)}} /> }
        
        <Countdown end_at={schedule.end_at} />
        
        { url && label && label.name && <span className="button-cta" style={{backgroundColor: label.color}}>{label.name}</span> }
        
      </div>
    </div>
  </React.Fragment> : null)
}



const layoutTypes = {
  text: {
    name: 'Text',
    icon: faLayoutText,
    SettingsComponent: TextBlockSettings,
    BlockComponent: TextComponent
  },
  button: {
    name: 'Button',
    icon: faLayoutButton
  },
  'button-thumbnail': {
    name: 'Thumbnail Button',
    icon: faLayoutThumbnail
  },
  'button-image-bg': {
    name: 'Background Image',
    icon: faLayoutImageBg
  },
  card: {
    name: 'Card',
    icon: faLayoutCard
  },
  feed: {
    name: 'Feed',
    icon: faLayoutFeed,
    SettingsComponent: FeedBlockSettings,
    BlockComponent: FeedBlockComponent
  },
  'feed-cards': {
    name: 'Feed',
    icon: faLayoutFeed,
    SettingsComponent: FeedBlockSettings,
    BlockComponent: FeedBlockComponent
  },
  'feed-tiles': {
    name: 'Feed',
    icon: faLayoutFeed,
    SettingsComponent: FeedBlockSettings,
    BlockComponent: FeedBlockComponent
  },
  'feed-mixed': {
    name: 'Feed',
    icon: faLayoutFeed,
    SettingsComponent: FeedBlockSettings,
    BlockComponent: FeedBlockComponent
  },
  'countdown': {
    name: 'Countdown',
    icon: faClock,
    hideControls: true,
    SettingsComponent: CountdownSettings,
    BlockComponent: CountdownComponent,
    initProps: {schedule_enabled: true}
  },
  default: {
    SettingsComponent: ButtonBlockSettings,
    BlockComponent: ButtonComponent
  }
}

const getLayoutType = (layout) => ({...layoutTypes['default'], ...(layoutTypes[layout] || {})})



const MessengersSettings = ({fields, setActionSheet, hideActionSheet}) => (
  <div>
    <FieldArray name={fields.name}>
      {({ fields }) => <SchemedList scheme={sublinksScheme['messengers']} fields={fields} />}
    </FieldArray>
  </div>
)

const SocialLinksSettings = ({fields, setActionSheet, hideActionSheet}) => (
  <div>
    <FieldArray name={fields.name}>
      {({ fields }) => <SchemedList scheme={sublinksScheme['social_links']} fields={fields} />}
    </FieldArray>
  </div>
)




class PoweredBySettings extends Component {
  constructor (props) {
    super(props)
    this.removeLogoToggle = this.removeLogoToggle.bind(this);
    this.state = {removeLogoPrompt: false}
  }
  
  removeLogoToggle (onSuccess){
    const { isSubscribed } = this.props
    return isSubscribed ? onSuccess : () => this.setState({removeLogoPrompt: true})
  }
  
  render () {
    const {submitting, values, isSubscribed, currentAccount} = this.props;
    const {removeLogoPrompt} = this.state;
    
    return (
      <div>
        <FormGroup className={classNames({'with-remove-logo-prompt': removeLogoPrompt})}>
          { ((values.settings || {}).remove_powered_by === true || (currentAccount || {}).is_verified === true) && <label style={{fontWeight: 'normal'}}><Field 
            name="settings.remove_powered_by"
            render={({input}) => <ToggleSwitch { ...{input:{...input, checked:!input.value, onChange: this.removeLogoToggle(() => input.onChange(!input.value))}} } />} 
            /> powered by Shor</label> }
          
          { !isSubscribed && removeLogoPrompt && <div className="error-tooltip" style={{padding:"1em", zIndex: 9}}>
            Subscribe to hide Shor branding.
            <div className="text-center mt-2"><ModalLink to="activate" color="white" size="sm" params={{size: "lg"}} style={{marginLeft: '1.5em'}}>Subscribe Now!</ModalLink></div>
          </div> }
      
          <div className={classNames({jumbotron: true, 'w-arrow':false, shake: !!(values.settings || {}).remove_powered_by})}>
            <p>Get up to $300 per each referral <span role="img" aria-label="Star-Struck">🤩</span> — <a href="https://shor.by/start-earning" target="_blank" rel="noopener noreferrer">learn more</a></p>
            <InputField name="gsm_partner_key" meta={{submitting}} parse={(value) => (value || '')} placeholder="Partner key or email" />
          </div>
      
        </FormGroup>
      </div>
    )
  }
}


//
// const BlockTypes = {
//   link: {
//     ActionComponent: ButtonBlockSettings,
//     BlockComponent: ButtonComponent,
//     title: "Link"
//   },
//   text: {
//     ActionComponent: TextBlockSettings,
//     BlockComponent: TextComponent,
//     title: "Title & Text",
//   }
// }
//

class Block extends Component {
  
  constructor (props){
    super(props)
    this.editBlock = this.editBlock.bind(this)
  }
  
  componentWillMount () {
    const { index, fields, pristine } = this.props;
    if (size(fields) === 1 && index === 0 && !pristine && fields.active){
      this.editBlock()
    }
  }
  
  componentWillReceiveProps (nextProps) {
    const { index, fields } = this.props;
    if (index === 0 && size(nextProps.fields) - size(fields) === 1 && fields.active){
      this.editBlock()
    }
  }
  
  
  editBlock (e){
    preventDefault(e);
    
    const { index, fields, setActionSheet } = this.props;
    // const blockType = this.blockType()
    const blockType = {ActionComponent: BlockSettings, title: "Block Settings"}
    
    if (blockType)
      setActionSheet({...blockType, onRemove: () => fields.remove(index), props: this.props});
  }
  
  render () {
    const { provided, snapshot, index, fields, name} = this.props;
    const blockParams = fields.value[index] || {};
    const layoutType = getLayoutType(blockParams.layout)
    
    const { BlockComponent } = layoutType;
    
    const image = (blockParams.meta || {}).image
    
    return ( BlockComponent ?  
      <div className={classNames({"links-block": true, dragging: snapshot.isDragging})} {...provided.dragHandleProps} onClick={this.editBlock}>
        <BlockComponent {...{name, image, ...blockParams}} />
      </div>
    : null )
  }
}





const TitleSettingsComponent = ({submitting}) => (
  <div>
    <FormGroup>
      <InputField 
        meta={{submitting}}
        parse={(val) => val === null ? '' : val}
        name={`title`} type="text"
        placeholder="Title"
        focusOnMount={300}
      />
    </FormGroup>

    <FormGroup>
      <InputField 
        meta={{submitting}}
        parse={(val) => val === null ? '' : val}
        name={`meta.description`} type="textarea"
        placeholder="Description"
      />
    </FormGroup>
  </div>
)

class TitleBlockComponent extends Component {
  constructor (props) {
    super(props)
    this.openSettings = this.openSettings.bind(this)
  }
  
  openSettings (e){
    preventDefault(e);
    const { setActionSheet } = this.props
    setActionSheet({ ActionComponent: TitleSettingsComponent, title: "Title & Description", props: this.props});
  }
  
  render (){
    const { title, meta } = this.props.values || {}
    const { description } = meta || {} 
    
    return (
      <div className="bio-title" onClick={this.openSettings}>
        { (title || (!title && !description)) && <h1 className={classNames({empty: !title})}>{title || <span>Title here</span>}</h1> }
        { description && <div className="bio-description" dangerouslySetInnerHTML={{__html: text2HTML(description)}} /> }
      </div>
    )
  }
}


const PoweredByShor = (props) => {
  const { remove_powered_by } = (props.values || {}).settings || {};
  
	return (<div className={classNames({"powered-by-shorby": true, "hidden": remove_powered_by})}>
    <span onClick={
      (e) => {
        preventDefault(e);
        props.setActionSheet({ActionComponent: PoweredBySettings, title: "Affiliate Settings", props: props});
      }
    }>
    {remove_powered_by && <FA icon={faEyeSlash} />}made on <strong className="domain-logo">shor</strong></span>
  </div>)
}




class HighlightControl extends React.Component {
  
  componentWillReceiveProps(nextProps) {    
    const { values: {settings} } = nextProps
    const oldSettings = this.props.values.settings
    
    if ( settings === oldSettings )
      return
    
    const highlighted = filter(settings.blocks, 'highlight') 
    
    if (highlighted.length <= 1)
      return
    
    const oldHighlighted = filter(oldSettings.blocks, 'highlight')
    
    const selected = difference(highlighted, oldHighlighted)[0]
    
    const newSettings = {...settings, 
      blocks: map(settings.blocks, (b) => (selected !== b ? {...b, highlight: false} : b))
    }
    nextProps.form.change('settings', newSettings)
  }
  
  render () {
    return null
  }
}


const InsightsButton = () => <RouteLink to="/" className="insights-button service-button">Insights</RouteLink>



class SmartPageForm extends Component {
  
  constructor (props){
    super(props)
    this.setActionSheet = this.setActionSheet.bind(this);
    this.hideActionSheet = this.hideActionSheet.bind(this);
    
    this.state = {
      actionSheetComponent: null,
      initialValues: this.props.initialValues
    }
  }
  
  componentWillMount (){
    const { listPixelSets } = this.props
    listPixelSets();
  }
  
  onSuccess(res) {
    const { addLinkSuccess, onSuccess } = this.props; 
    addLinkSuccess(res);
    this.resetUnsavedChanges();
    
    if ( onSuccess && typeof onSuccess === 'function')
      onSuccess(res);
  }
  
  setActionSheet (component) {
    this.setState({actionSheetComponent: component});
  }
  
  hideActionSheet (e) {
    if (e && e.defaultPrevented)
      return
    this.setActionSheet(null)
  }
  
  
  getUnsavedChangesId () {
    const initialValues = this.props.initialValues || {};
    return initialValues.id || 'new';
  }
  
  resetUnsavedChanges () {
    sessionStorage.removeItem(`unsvd_pg_${this.getUnsavedChangesId()}`);
  }
  
  render() {
    const { showFTE, onSubmit, onSuccess, initialValues, onFail, resetOnSuccess, currentUser, currentAccount, isSubscribed } = this.props;
    const { actionSheetComponent } = this.state;
    // const setActionSheet = this.setActionSheet
    const hideActionSheet = this.hideActionSheet;
    
    const disableSubmitOnKeyEnter = (e) => {
      if ( e.target.tagName === 'TEXTAREA')
        return;
      
      if (e.key === 'Enter' || e.target.keyCode === 13){
        preventDefault(e);
        e.stopPropagation();
        hideActionSheet();
      }
    }
    
    const { ref, special_k, special_h } = initialValues || {};
    
    return (
      <Form
        {...{onSubmit: (onSubmit || this.onSubmit), onSuccess, onFail, resetOnSuccess, initialValues}}
        decorators={[ sublinksUrlDecorator ]}
        mutators={{...arrayMutators, setFieldData, setErrors}}
        render={({ handleSubmit, submitError, pristine, submitting, values, form, form: {reset, focus, mutators: { push, unshift }} }) => (
          <form onSubmit={handleSubmit} onKeyPress={disableSubmitOnKeyEnter} noValidate={true}>
            { (!currentUser || !currentUser.fte_smartpage_completed || showFTE) && <SmartPageFTE show={showFTE} />}
            
            {true && <AutoSaveToSession initialValues={initialValues} id={`unsvd_pg_${this.getUnsavedChangesId()}`} />}
            
            <FormSpy
              subscription={{ values: true }}
              component={HighlightControl}
            />
            
            <Theme {...(values.settings || {})} />
            
            <ResetOnSuccess enabled={true || resetOnSuccess || false} reset={reset} />
            <PreloadUniqueSlug />
            
            <SignupModalTrigger forceSignup={true} initialValues={{ref, special_k, special_h}} onSuccess={() => handleSubmit(values)} />
            <ActivateModalTrigger />
            <AccountLimitsError />
            
            <div className="page-header">
              <SettingsButton values={values} form={form} setActionSheet={this.setActionSheet} hideActionSheet={this.hideActionSheet} />
              {currentUser && <InsightsButton />}
              
              <Field name="meta.image"
                component={AvatarUploader}
              />
              
              <TitleBlockComponent {...{submitting, values, setActionSheet: this.setActionSheet, hideActionSheet: this.hideActionSheet}} />
            </div>
            
            <FieldArray name="settings.messengers">
              {({ fields }) => <MessengersList focus={focus} push={push} unshift={unshift} submitting={submitting} fields={fields} values={values} setActionSheet={this.setActionSheet} hideActionSheet={this.hideActionSheet} />}
            </FieldArray>
            
            <FieldArray name="settings.blocks">
              {({ fields }) => <BlocksList focus={focus} push={push} unshift={unshift} submitting={submitting} pristine={pristine} fields={fields} values={values} setActionSheet={this.setActionSheet} hideActionSheet={this.hideActionSheet} />}
            </FieldArray>
            
            <FieldArray name="settings.social_links">
              {({ fields }) => <SocialLinksList focus={focus} push={push} unshift={unshift} submitting={submitting} fields={fields} values={values} setActionSheet={this.setActionSheet} hideActionSheet={this.hideActionSheet} />}
            </FieldArray>
            
            <PoweredByShor isSubscribed={isSubscribed} currentAccount={currentAccount} values={values} setActionSheet={this.setActionSheet} hideActionSheet={this.hideActionSheet} />
            
            
            <SmartPageActionBar />
            <SmartPageActionSheet component={actionSheetComponent} values={values} />
            
            {false && <pre>{JSON.stringify(values, 0, 2)}</pre>}
          </form>
        )}
      />
    );
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(SmartPageForm);


// WEBPACK FOOTER //
// ./src/components/SmartPages/SmartPageForm.js